const init = () => {
    const handleScroll = () => {
        document.querySelectorAll(".ns-image-green-aside__image-wrap").forEach((imageWrap) => {
            const scrollTopPosition = window.scrollY;
            const scrollBottomPosition = window.scrollY + window.innerHeight;
            const imageWrapOffsetTopPosition = imageWrap.offsetTop;
            const imageWrapOffsetBottomPosition = imageWrap.offsetTop + imageWrap.clientHeight;
            const imageWrapHeight = imageWrap.clientHeight;
            if(scrollTopPosition < imageWrapOffsetBottomPosition && scrollBottomPosition > imageWrapOffsetTopPosition){
                const viewBottomPosition = scrollTopPosition - imageWrapOffsetBottomPosition;
                const percentOfView = 10 * ((viewBottomPosition - .5*imageWrapHeight) / window.innerHeight);
                imageWrap.querySelector("img").style.top = `${percentOfView + 10}%`;
            }
        });
    }
    document.addEventListener("scroll", handleScroll);
}
window.addEventListener("DOMContentLoaded", init, false);
